import React, { Component } from 'react';

import Login from './components/generator/Login';
import Step1 from './components/generator/Step1';
import Step2 from './components/generator/Step2';
import Step3 from './components/generator/Step3';
import Final from './components/generator/Final';
import SharePanel from './components/generator/SharePanel';
import EmailSuccessPanel from './components/generator/EmailSuccessPanel';
import StepsMap from './components/generator/StepsMap';
import SnapshotLayer from './components/generator/SnapshotLayer';
import * as Utils from './utils/utils';

import './../scss/App.scss';
import { trackingWrapper } from './utils/analytics';




class App extends Component {

	constructor(props){
		super(props);

		this.configData = null;
		this.jsonData = null;
		
		this.key = 0;

		this.state = {
			"dataReady" : false,
			"step": 0,
			"displayName": "",
			"firstName": "",
			"email": "",
			"agreeEmail": true,
			"categoryData": null,
			"question": null,
			"questionID": null,
			"answers": null,
			"answersKey": 0,
			"authorizeShareChecked": false,
			"showSharePanel": false,
			"showEmailSuccessPanel": false,
			"renderSnapshot": false,
			"publicID": "",
			"shareURL": ""
		}

		//

		this.handleSignUp = this.handleSignUp.bind(this);
		this.handleCategoryClicked = this.handleCategoryClicked.bind(this);
		this.handleQuestionsClicked = this.handleQuestionsClicked.bind(this);
		this.handleAnswersCompleted = this.handleAnswersCompleted.bind(this);
		this.handleUpdateAnswers = this.handleUpdateAnswers.bind(this);
		this.handleUpdateAnswersKey = this.handleUpdateAnswersKey.bind(this);
		this.handleBackBtn = this.handleBackBtn.bind(this);
		this.handleShareBtn = this.handleShareBtn.bind(this);
		this.handleShareClose = this.handleShareClose.bind(this);
		this.handleSnapshot = this.handleSnapshot.bind(this);
		this.handleShareAuthorizationChecked = this.handleShareAuthorizationChecked.bind(this);
		this.handleEmailSuccess = this.handleEmailSuccess.bind(this);
		this.handleEmailSuccessClose = this.handleEmailSuccessClose.bind(this);
	}

	componentDidMount(){
		//console.log("componentDidMount");
		this.initData();

		// tracking
		trackingWrapper('event', 'ASDIY-page-loaded', {'event_category':'america-says-diy'});

		//

		// resizing for layout
		window.$(window).resize(() => {
			this.forceUpdate();
		});
	}

	initData(){
		console.log("App :: initData - v3");

		const _this = this;

		/*
		window.$.when(
			// load config.json
			window.$.getJSON(("data/data.json"), function(data) {
				_this.jsonData = {...data};
			})
		).then(function() {
			if(_this.jsonData !== null){
				_this.setState({
					"dataReady": true
				});
			}
		});
		*/

		// load config.json
		window.$.getJSON(("data/config.json"), function(data) {
			_this.configData = Utils.deepCopyFunction(data);
			window.app.configData = _this.configData;
		})
		.then(function() {
			let gameDataSrc = "data/data.json";

			if(_this.configData.useAPI_fetch){
				const apiSource = _this.configData.APIsource;
				gameDataSrc = _this.configData[apiSource].fetchQuestionData;
			}

			console.log("gameDataSrc", gameDataSrc);

			// load category/question data.json
			window.$.getJSON((gameDataSrc), function(data) {
				_this.jsonData = Utils.deepCopyFunction(data);
				window.app.jsonData = _this.jsonData;

				console.log("gameData loaded");
			})
			.then(function() {
				if(_this.jsonData !== null){
					_this.setState({
						"dataReady": true
					});
				}
				
				console.log("this.jsonData ready", _this.jsonData);
			});
		});
	}

	handleSignUp(firstName, displayName, email, agreeEmail){
		//console.log("loginHandler - name:", name );

		let customName = Utils.capitalizeWord(displayName);

		if(customName === ""){
			customName = Utils.capitalizeWord(firstName);
		}

		this.setState({
			"firstName": Utils.capitalizeWord(firstName),
			"displayName": customName,
			"email": email,
			"agreeEmail": agreeEmail,
			"step": 1
		});
	}

	handleCategoryClicked(categoryData){
		//console.log("App handleCategoryClicked categoryData:", categoryData);
		this.setState({
			"categoryData": categoryData,
			"step": 2
		});
	}

	handleQuestionsClicked(questionID, question){
		//console.log("App handleQuestionClicked question:", question);

		// if user goes back and changes the question, clear the answers on next step
		if(question !== this.state.question){
			this.setState({
				"question": question,
				"questionID": questionID,
				"answers": null,
				"step": 3
			});
		}
		else {
			this.setState({
				"question": question,
				"step": 3
			});
		}
	}

	handleAnswersCompleted(public_id, shareURL){
		console.log("handleAnswersCompleted - public id:", public_id);
		this.setState({
			"step": 4,
			"publicID": public_id,
			"shareURL": shareURL
		});
	}

	handleSnapshot(answers){
		///console.log("handleSnapshot");
		this.setState({
			"answers": answers,
			"renderSnapshot": true
		});
	}

	handleUpdateAnswers(answers){
		this.setState({
			"answers": answers
		});
	}

	handleUpdateAnswersKey(key){
		this.setState({
			"answersKey": key
		});
	}

	handleShareAuthorizationChecked(status){
		this.setState({
			"authorizeShareChecked": status
		});
	}

	handleBackBtn(){
		//console.log("backBtn");

		let backStep = this.state.step - 1;

		if(backStep < 0){
			backStep = 0;
		}

		this.setState({
			"step": backStep
		});
	}

	handleShareBtn(){
		//console.log("shareBtn");

		this.setState({
			"showSharePanel": true
		});

		// tracking
		trackingWrapper('event', 'ASDIY-share-popup', {'event_category':'america-says-diy'});
	}

	handleEmailSuccess(){
		this.setState({
			"showSharePanel": false,
			"showEmailSuccessPanel": true
		});
	}

	handleEmailSuccessClose(){
		this.setState({
			"showEmailSuccessPanel": false
		});
	}

	handleShareClose(){
		//console.log("close share panel");

		this.setState({
			"showSharePanel": false
		});

		// tracking
		trackingWrapper('event', 'ASDIY-share-popup-close', {'event_category':'america-says-diy'});
	}

	renderLogin(){
		if(this.state.step === 0){
			return(
				<Login handleSignUp={this.handleSignUp} firstName={this.state.firstName} displayName={this.state.displayName} email={this.state.email} agreeEmail={this.state.agreeEmail} />
			);
		}
	}

	renderStep1(){
		if(this.state.step === 1){
			return(
				<Step1 key={this.key++} data={this.jsonData} handleCategoryClicked={this.handleCategoryClicked} />
			);
		}
	}

	renderStep2(){
		if(this.state.step === 2){
			return(
				<Step2 key={this.key++} categoryData={this.state.categoryData} displayName={this.state.displayName} handleQuestionsClicked={this.handleQuestionsClicked} />
			);
		}
	}

	renderStep3(){
		if(this.state.step === 3){
			return(
				<Step3 question={this.state.question} questionID={this.state.questionID} handleAnswersCompleted={this.handleAnswersCompleted} answers={this.state.answers} firstName={this.state.firstName} email={this.state.email} displayName={this.state.displayName} handleUpdateAnswers={this.handleUpdateAnswers} answersKey={this.state.answersKey} handleUpdateAnswersKey={this.handleUpdateAnswersKey} handleSnapshot={this.handleSnapshot} authorizeShareChecked={this.state.authorizeShareChecked} handleShareAuthorizationChecked={this.handleShareAuthorizationChecked} />
			);
		}
	}

	renderFinal(){
		if(this.state.step === 4){
			//console.log("final answers", this.state.answers);
			return(
				<Final key={this.key++} question={this.state.question} answers={this.state.answers} />
			);
		}
	}

	renderStepsMap(){
		if(this.state.step === 1 || this.state.step === 2 || this.state.step === 3){
			return(
				<StepsMap step={this.state.step} />
			);
		}
	}

	renderSnapshotLayer(){
		if(this.state.step >= 3 && this.state.renderSnapshot){
			return(
				<SnapshotLayer key={this.key++} firstName={this.state.firstName} displayName={this.state.displayName} question={this.state.question} answers={this.state.answers} handleSnapshot={this.handleSnapshot} />
			);
		}
	}

	renderSharePanel(){
		if(this.state.showSharePanel && this.state.dataReady){
			return(
				<SharePanel key={this.key++} question={this.state.question} answers={this.state.answers} handleShareClose={this.handleShareClose} publicID={this.state.publicID} shareURL={this.state.shareURL} handleEmailSuccess={this.handleEmailSuccess} email={this.state.email} />
			);
		}
	}

	renderEmailSuccessPanel(){
		if(this.state.showEmailSuccessPanel && this.state.dataReady){
			return(
				<EmailSuccessPanel handleEmailSuccessClose={this.handleEmailSuccessClose} />
			)
		}
	}

	renderShareBtn(){
		if(this.state.step === 4 && this.state.showSharePanel === false){
			return(
				<div className="shareBtn" onClick={this.handleShareBtn}>SHARE WITH FRIENDS<span className="arrow fa-solid fa-angle-right"></span></div>
			);
		}
	}

	renderBackBtn(){
		if(this.state.step > 0){
			return(
				<div className="backBtn" onClick={this.handleBackBtn}><span className="fa-solid fa-angle-left"></span>BACK</div>
			);
		}
	}

	renderPreviewBtn(){
		if(this.state.step === 4 && this.state.showSharePanel === false){
			return(
				<a className="previewBtn" href={this.state.shareURL} target="_blank"><span className="fa-solid fa-gamepad" onClick={() => {trackingWrapper('event', 'ASDIY-share-test-game', {'event_category':'america-says-diy'})}}></span>PLAY YOUR GAME</a>
			);
		}
	}

	renderTuneIn(){
		return(
			<div className="tuneIn"><gsntv-wc-tune-in show-id="asdiy-generator"></gsntv-wc-tune-in></div>
		)
	}

	renderDisplayName(){
		let name = this.state.firstName;

		if(this.state.displayName !== ""){
			name = this.state.displayName;
		}

		if(name !== ""){
			let edition = name + " Edition";

			return(
				<div>
					<div className="custom-name">{edition}</div>
				</div>
			)
		}
	}

	render() {
		const availWidth = window.$(window).width();
		const availHeight = window.$(window).height();
		const widthHeightRatio = availWidth / availHeight;

		let layoutMode = "";

		if(widthHeightRatio <= .65){
			layoutMode = "tablet phone";
		}
		else if(widthHeightRatio <= .85){
			layoutMode = "tablet";
		}

		layoutMode += " " + Utils.detectDeviceType();

		//

		let wipeClass = "";

		if(this.state.dataReady){
			wipeClass = " hide";
		}

		return (
			<div className={"main_wrapper " + layoutMode + " step" + this.state.step} key={this.state.key}>
				<div className="content">
					<div className="logo_wrapper">
						<div>
							<div className="logo"></div>
						</div>
						{this.renderDisplayName()}
					</div>
					{this.renderLogin()}
					{this.renderStep1()}
					{this.renderStep2()}
					{this.renderStep3()}
					{this.renderFinal()}
					{this.renderTuneIn()}
					{this.renderStepsMap()}
					{this.renderBackBtn()}
					{this.renderShareBtn()}
					{this.renderPreviewBtn()}
					{this.renderSharePanel()}
					{this.renderEmailSuccessPanel()}
				</div>
				{this.renderSnapshotLayer()}
				<div className={"wipe" + wipeClass}></div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js